//TODO : Refactor after ai
/**
 * Fester Demo-Zugang für den Prototyp. Im Mock-Modus ist das Anmeldeformular
 * damit vorausgefüllt; die Mock-Anmeldung akzeptiert ihn wie jede andere
 * Eingabe. Kein echtes Konto, kein Geheimnis – nur damit niemand tippen muss.
 */
export const DEMO_LOGIN = {
  email: "demo@viacid.example",
  passwort: "viacid-demo",
} as const;
